import { ControlFlags } from '../common/control-flags-enum'

/**
 * @readonly
 * @enum {string}
 */
export const ObjectControlFlags = {
    ACKNOWLEDGE_EVENT: ControlFlags.ACKNOWLEDGE_EVENT,
    ASSETS: ControlFlags.ASSETS,
    BATTERY_INSIGHT: ControlFlags.BATTERY_INSIGHT,
    CAMERA_FEATURE_BASIC_INT: ControlFlags.CAMERA_FEATURE_BASIC_INT,
    CAMERA_FEATURE_BASIC: ControlFlags.CAMERA_FEATURE_BASIC,
    CAMERA_FEATURE_LIVE_INT: ControlFlags.CAMERA_FEATURE_LIVE_INT,
    CAMERA_FEATURE_LIVE: ControlFlags.CAMERA_FEATURE_LIVE,
    CAMERA_FEATURE_PLUS_INT: ControlFlags.CAMERA_FEATURE_PLUS_INT,
    CAMERA_FEATURE_PLUS: ControlFlags.CAMERA_FEATURE_PLUS,
    CHANGE_OBJECT_GROUP_MEMBERSHIP: ControlFlags.CHANGE_OBJECT_GROUP_MEMBERSHIP,
    COLD_CHAIN: ControlFlags.COLD_CHAIN,
    COLD_CHAIN_REPORTING: ControlFlags.COLD_CHAIN_REPORTING,
    COLD_CHAIN_INVERTABLE_IO: ControlFlags.COLD_CHAIN_INVERTABLE_IO,
    DEVICE_HEARTBEAT_SUPPORT: ControlFlags.DEVICE_HEARTBEAT_SUPPORT,
    DRIVER_ASSIGNMENT: ControlFlags.DRIVER_ASSIGNMENT,
    EDIT_CAMERAS: ControlFlags.EDIT_CAMERAS,
    EDIT_EVENT_FORWARDING_CONFIG: ControlFlags.EDIT_EVENT_FORWARDING_CONFIG,
    EDIT_OBJECT_DEVICE_CONFIGURATION: ControlFlags.EDIT_OBJECT_DEVICE_CONFIGURATION,
    EDIT_OBJECT: ControlFlags.EDIT_OBJECT,
    EDIT_VEHICLE_IMAGES: ControlFlags.EDIT_VEHICLE_IMAGES,
    ENGINE_TOTAL_HOURS: ControlFlags.ENGINE_TOTAL_HOURS,
    EV_INSIGHTS_AND_RELIABILITY: ControlFlags.EV_INSIGHTS_AND_RELIABILITY,
    EV_NOTIFICATIONS: ControlFlags.EV_NOTIFICATIONS,
    FUEL_DATA: ControlFlags.FUEL_DATA,
    IMMOBILIZER: ControlFlags.IMMOBILIZER,
    IMMOBILIZER_OUTPUT: ControlFlags.IMMOBILIZER_OUTPUT,
    GEN_IO: ControlFlags.GEN_IO,
    HOURS_OF_SERVICE: ControlFlags.HOURS_OF_SERVICE,
    JACKFISH_DATA_L: ControlFlags.JACKFISH_DATA_L,
    JACKFISH_DATA_M: ControlFlags.JACKFISH_DATA_M,
    JACKFISH_DATA_S: ControlFlags.JACKFISH_DATA_S,
    JACKFISH_DATA_XL: ControlFlags.JACKFISH_DATA_XL,
    JACKFISH_DATA_XS: ControlFlags.JACKFISH_DATA_XS,
    LOGBOOK_VIA_IO2: ControlFlags.LOGBOOK_VIA_IO2,
    OPTIONAL_ONETIME_FEE: ControlFlags.OPTIONAL_ONETIME_FEE,
    ORDER_DOCUMENT_SUPPORT: ControlFlags.ORDER_DOCUMENT_SUPPORT,
    ORDER_PLANNER_SUPPORT: ControlFlags.ORDER_PLANNER_SUPPORT,
    ORDER_SCHEDULE_OPTIMIZATION: ControlFlags.ORDER_SCHEDULE_OPTIMIZATION,
    PERFORM_FUNCTIONS: ControlFlags.PERFORM_FUNCTIONS,
    PERFORM_OBJECT_FUNCTIONS: ControlFlags.PERFORM_OBJECT_FUNCTIONS,
    PLUGINS: ControlFlags.PLUGINS,
    PURCHASE_FUEL_CARD: ControlFlags.PURCHASE_FUEL_CARD,
    QUERY_POSITION: ControlFlags.QUERY_POSITION,
    REMAINING_DRIVING_TIME: ControlFlags.REMAINING_DRIVING_TIME,
    REMOTE_TACHO: ControlFlags.REMOTE_TACHO,
    RESOLVE_EVENT: ControlFlags.RESOLVE_EVENT,
    SATELLITE: ControlFlags.SATELLITE,
    SATELLITE_DATA_M: ControlFlags.SATELLITE_DATA_M,
    SATELLITE_DATA_L: ControlFlags.SATELLITE_DATA_L,
    SATELLITE_DATA_S: ControlFlags.SATELLITE_DATA_S,
    SATELLITE_DATA_XL: ControlFlags.SATELLITE_DATA_XL,
    SATELLITE_DATA_XS: ControlFlags.SATELLITE_DATA_XS,
    SEND_MESSAGE: ControlFlags.SEND_MESSAGE,
    SEND_ORDER: ControlFlags.SEND_ORDER,
    SEND_ROUTE: ControlFlags.SEND_ROUTE,
    SEND_TEXT: ControlFlags.SEND_TEXT,
    SERVICE_FEE: ControlFlags.SERVICE_FEE,
    SMART_NOTIFICATION_2: ControlFlags.SMART_NOTIFICATION_2,
    SMART_TACHOGRAPH_SUPPORT: ControlFlags.SMART_TACHOGRAPH_SUPPORT,
    SWAP_VEHICLE: ControlFlags.SWAP_VEHICLE,
    TPMS_NOTIFICATION_VIAIO_2: ControlFlags.TPMS_NOTIFICATION_VIAIO_2,
    TRACK_HD: ControlFlags.TRACK_HD,
    TRACK_ONLY: ControlFlags.TRACK_ONLY,
    UPGRADE_PND: ControlFlags.UPGRADE_PND,
    VEHICLE_DIAGNOSTICS_HCV: ControlFlags.VEHICLE_DIAGNOSTICS_HCV,
    VEHICLE_DIAGNOSTICS_LCV: ControlFlags.VEHICLE_DIAGNOSTICS_LCV,
    VIEW_CAMERAS: ControlFlags.VIEW_CAMERAS,
    VIEW_LOGBOOK: ControlFlags.VIEW_LOGBOOK,
    VIEW_MESSAGE: ControlFlags.VIEW_MESSAGE,
    VIEW_OBJECT: ControlFlags.VIEW_OBJECT,
    VIEW_POSITION: ControlFlags.VIEW_POSITION,
    VIEW_TPMS_DATA: ControlFlags.VIEW_TPMS_DATA,
    WF_TPMS_CAN: ControlFlags.WF_TPMS_CAN,
    VIEW_TRACK: ControlFlags.VIEW_TRACK,
    VORTEX_DELETE: ControlFlags.VORTEX_DELETE,
    [ControlFlags.ACCESS_EXTERNAL_TACHO_GRAPH]: ControlFlags.ACCESS_EXTERNAL_TACHO_GRAPH,
    [ControlFlags.ASSIGN_OBJECT_TO_DRIVER_GROUP]: ControlFlags.ASSIGN_OBJECT_TO_DRIVER_GROUP
}
Object.freeze(ObjectControlFlags)
